import React from 'react';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

export const DraftsDrawer = ({ onClose }) => {
  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: 'Drafts' }}
      onClose={onClose}
    >
      <div>Drafts Table</div>
    </FPDrawer>
  );
};
